<template>
  <div class="position-relative">
    <div class="form-check form-switch pr-3">
      <input
          class="form-check-input cursor-pointer"
          type="checkbox"
          :checked="initialState == 1"
          @change="toggle2FA"
      />
      <label
        v-if="showLabel"
          class="form-check-label cursor-pointer"
          >{{
              initialState == 1
                  ? "2FA Enabled"
                  : "2FA Disabled"
          }}
      </label>
  </div>
  </div>
</template>

<script>
import { useStore } from "vuex";

export default {
  name: 'TwoFactorToggle',
  
  props: {
    initialState: {
      type: [Boolean, Number],
      required: true
    },
    userId: {
      type: [String, Number],
      required: true
    },
    showLabel: {
      type: [Boolean],
      default: () => false
    }
  },

  setup() {
    const store = useStore();

    return {
      store
    }
  },  

  data() {
    return {
      isEnabled: this.initialState,
      isLoading: false
    }
  },

  watch: {
    initialState(newValue) {
      this.isEnabled = newValue;
    }
  },

  methods: {
    toggle2FA() {
      if (this.isLoading) return;
      
      try {
        this.isLoading = true;
        const newState = !this.isEnabled;

        this.isEnabled = newState;
        this.$emit('update:modelValue', newState);
      } catch (error) {
        this.$emit('error', error.response?.data?.message || 'Failed to update setting');
      } finally {
        this.isLoading = false;
      }
    }
  },

  emits: ['update:modelValue', 'error']
}
</script>